import React from 'react';
import ResizeObserverPolyfill from 'resize-observer-polyfill';

export const useIsContentOverflowing = (
  labelRef: React.MutableRefObject<any>,
  itemLabel?: string,
  selected?: boolean
) => {
  const [isContentOverflowing, setIsContentOverflowing] = React.useState(false);
  React.useEffect(() => {
    if (!window.ResizeObserver) {
      // polyfill for older browsers or disabled iOS Safari setting
      window.ResizeObserver = ResizeObserverPolyfill;
    }
    const labelElement = labelRef?.current;

    const updateShowTooltip = (element: HTMLElement) => {
      // Conditionally show tooltip only if label text is truncated
      const labelIsOverflowing = element.scrollWidth > element.clientWidth;
      /* istanbul ignore next */
      if (labelIsOverflowing !== isContentOverflowing) {
        setIsContentOverflowing(labelIsOverflowing);
      }
    };

    const resizeObserver = new ResizeObserver((entries) => {
      const updatedLabelElement = entries[0].target;
      updateShowTooltip(updatedLabelElement);
    });

    if (labelElement) {
      updateShowTooltip(labelElement);
      resizeObserver.observe(labelElement);
    }

    // Clean up the observer when the component is unmounted
    return () => {
      resizeObserver.disconnect();
    };
  }, [labelRef, isContentOverflowing, itemLabel, selected]);
  return isContentOverflowing;
};
